import RestService from '../services/rest';

// GET
async function getRangeRestrictions() {
  return RestService.getAuthenticated('rangeRestriction/list/all');
}

async function getRangeRestriction(rangeRestrictionId) {
  return RestService.getAuthenticated(`rangeRestriction/detail?rangeRestrictionId=${rangeRestrictionId}`);
}

// POST
async function createRangeRestriction(rangeRestriction) {
  return RestService.postAuthenticated('rangeRestriction/create', rangeRestriction);
}

// PUT
async function updateRangeRestriction(rangeRestriction) {
  return RestService.putAuthenticated('rangeRestriction/update', rangeRestriction);
}

// DELETE
async function deleteRangeRestriction(rangeRestrictionId) {
  return RestService.postAuthenticated('rangeRestriction/delete', { rangeRestrictionId });
}

export default {
  getRangeRestrictions,
  getRangeRestriction,
  createRangeRestriction,
  updateRangeRestriction,
  deleteRangeRestriction,
};
